/**
 * External Dependencies
 */
import 'jquery';
import 'lity';
import lozad from 'lozad';
import {
  WOW
} from 'wowjs';
import {
  gsap,
  ScrollTrigger,
  ScrollToPlugin,
  TweenMax
} from 'gsap/all';
import {
  each
} from 'jquery';
import Swiper from 'swiper/bundle';

$(() => {
  var wow = new WOW({
    live: false,
  });
  wow.init();

  const observer = lozad();
  observer.observe();

  gsap.install(window);

  gsap.registerPlugin(ScrollTrigger);

  $('[data-fancybox]').fancybox({
    afterShow: function () {
      $('html').css('overflow', 'hidden');
    },
    afterClose: function () {
      $('html').css('overflow', 'visible');
    }
  });

  ///////// Pageloader /////////
  $('.page-loader').fadeOut(1500);

  ///////// Safari Height /////////
  var appHeight = () => {
    var doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  };

  window.addEventListener('resize', appHeight);
  appHeight();

  ///////// Header Height /////////
  function headerHeight() {
    if ($(".banner").length) {
      var header = document.getElementsByClassName("header")[0];
      var header_height = header.offsetHeight + "px";
      $(".banner").css({
        "height": "calc(100vh - " + header_height + ")",
      });
    }
  }

  $(window).on("load", function () {
    headerHeight();
  });

  $(window).resize(function () {
    headerHeight();
  });

  ///////// FadeInUp Gsap Animation /////////
  if ($('.animated-boxes').length) {
    const boxes = gsap.utils.toArray('.animated-boxes .animated-item');
    boxes.forEach((box, i) => {
      const anim = gsap.fromTo(box, {
        autoAlpha: 0,
        y: 80
      }, {
        duration: 1,
        autoAlpha: 1,
        y: 0
      });
      ScrollTrigger.create({
        trigger: box,
        animation: anim,
        toggleActions: 'play none none none',
        once: true,
      });
    });
  }


  /** Check # value  **/
  var hash = $(location).prop('hash');
  if (hash) {
    var hash = hash.replace('#', '');
    if ($('.tabs').length) {
      if ($('#' + hash).length) {
        $('#' + hash)
          .parent('ul')
          .children('li')
          .removeClass('active');
        $('#' + hash).addClass('active');
        $('body .tabs_container .tab_content[data-tab=' + hash + ']')
          .parent()
          .children('.tab_content')
          .removeClass('active');
        $('body .tabs_container .tab_content[data-tab=' + hash + ']').addClass(
          'active'
        );
      }
    }
  }

  ///////// Tabs /////////
  $('ul.tabs li').click(function () {
    var $this = $(this);
    var $theTab = $(this).attr('id');
    if ($this.hasClass('active')) {
      // do nothing
    } else {
      $this.closest('.tabs_wrapper').find('ul.tabs li, .tabs_container .tab_content').removeClass('active');
      $('.tabs_container .tab_content[data-tab="' + $theTab + '"], ul.tabs li[id="' + $theTab + '"]').addClass('active');

      // fadeinup animation
      const boxes = gsap.utils.toArray('.animated-boxes .tabs_container .tab_content[data-tab="' + $theTab + '"] .animated-item');
      boxes.forEach((box, i) => {
        const anim = gsap.fromTo(box, {
          autoAlpha: 0,
          y: 50
        }, {
          duration: 1,
          autoAlpha: 1,
          y: 0
        });
        ScrollTrigger.create({
          trigger: box,
          animation: anim,
          toggleActions: 'play none none none',
          once: true,
        });
      });
    }
  });

  ///////// Menu /////////
  var navigation = new TimelineLite({
    paused: true,
    reversed: true
  });
  navigation.to(".main-nav", 0.5, {
    opacity: 1,
    display: 'block'
  }).from(".main-nav__col", 0.5, {
    opacity: 0,
    y: 30
  });

  $(".menu-open-test,[data-menu-toggle]").click(function () {
    navigation.reversed() ? navigation.play() : navigation.reverse();
    $('html').toggleClass('overflow-hidden mr-15');
    $('body').toggleClass('menu-open');
  })

  ///////// According /////////
  $('.faq .panel-heading').click(function () {
    $(this).siblings('.panel-collapse').slideToggle();
    $(this).find('i').toggleClass('fa-plus fa-minus');
  });

  ///////// Youtube video /////////
  if ($('.youtube-video').length) {
    new Swiper('.gallery-thumbs', {
      loop: true,
      slidesPerView: 3,
      paginationClickable: true,
      spaceBetween: 25,
      navigation: {
        nextEl: '.youtube-video .swiper-button-next',
        prevEl: '.youtube-video .swiper-button-prev',
      },
      breakpoints: {
        1920: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        2: {
          slidesPerView: 1,
          spaceBetween: 20
        }
      }
    });

    $(window).on('load resize', function () {
      if ($(window).innerWidth() <= 767) {
        $('[data-youtube-iframe-main]').remove();
        $('[data-youtube-video] [data-youtube-item]').each(function (i, ele) {
          var VideSRC = $(this).children('a').attr('data-youtube-src');
          $(this).children('a').attr('data-src', VideSRC);
          $(this).children('a').attr('data-fancybox', '');
        });

      } else {
        var iframeSrc = $('[data-youtube-video] [data-youtube-item]:first-child [data-youtube-src]').data('youtube-src');
        $('[data-youtube-iframe]').attr('src', iframeSrc);
        $('[data-youtube-item]').click(function () {
          var videoSrc = $(this).find('a').data('youtube-src');
          $('[data-youtube-iframe]').attr('src', videoSrc);
        })
      }
    })

  }

  if ($('.elephant-slider').length) {
    new Swiper('.elephant-slider', {
      loop: true,
      speed: 1000,
      paginationClickable: true,
      slidesPerView: 1,
      navigation: {
        nextEl: '.elephant-slider-container .swiper-button-next',
        prevEl: '.elephant-slider-container .swiper-button-prev',
      }
    });
  }

  if ($('.timeline-slider-container').length) {
    new Swiper('.timeline-slider-container', {
      loop: true,
      speed: 1000,
      paginationClickable: true,
      spaceBetween: 15,
      slidesPerView: 2.2,
      navigation: {
        nextEl: '.timeline-slider .swiper-button-next',
        prevEl: '.timeline-slider .swiper-button-prev',
      },
      breakpoints: {
        1920: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 2.2,
        },
        576: {
          slidesPerView: 2.2,
        },
        2: {
          slidesPerView: 1.2,
        }
      }
    });
  }

  if ($('.pd-gallery-slider').length) {
    // var slider = new Swiper ('.pd-gallery-slider', {
    //     slidesPerView: 1,
    //     centeredSlides: true,
    //     loop: true,
    //     loopedSlides: 6, 
    //     navigation: {
    //         nextEl: '.swiper-button-next',
    //         prevEl: '.swiper-button-prev',
    //     },
    // });
    // var thumbs = new Swiper ('.pd-gallery-thumbs', {
    //     slidesPerView: 3,
    //     spaceBetween: 10,
    //     centeredSlides: true,
    //     loop: true,
    //     slideToClickedSlide: true,
    // });

    // slider.controller.control = thumbs;
    // thumbs.controller.control = slider;

    var galleryThumbs = new Swiper('.pd-gallery-thumbs', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
    var galleryTop = new Swiper('.pd-gallery-slider', {
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  }



  if ($('.donate_variant_content').length) {
    $('.donate_variant_content').first().removeClass('hidden');
    $('input[type=radio][name=donate_variant]').change(function () {
      $('.donate_variant_content').addClass('hidden');
      var new_varinat = $(this).attr('id');
      var new_url = $(this).data('link');
      $('.donate_variant_content-' + new_varinat).removeClass('hidden');
      $('.donate-atc-btn').attr('href', new_url);
    });
  }

  // setInterval(function () {
  //     $('.added_to_cart.wc-forward').fadeOut('fast');
  // }, 10000);

  // load more posts 
  if ($('#post-list-div').length) {
    var ppp = $('#ppp').val();
    var pageNumber = 0;
    loadmore_posts();
  }

  $('body').on('click', '#post-lm-btn a', function () {
    loadmore_posts();
  });

  function loadmore_posts() {
    pageNumber++;
    var activecat_id = '';
    var activeauthor_id = '';
    var search_by = '';
    if ($('#ppp').length) {
      activecat_id = $('#activecat_id').val();
      activeauthor_id = $('#activeauthor_id').val();
      search_by = $('#search_by').val();
    }
    $("#post-lm-btn a").text('Loading...');
    var str = '&search_by=' + search_by + '&activecat_id=' + activecat_id + '&activeauthor_id=' + activeauthor_id + '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_post_ajax';
    $.ajax({
      type: "POST",
      dataType: "html",
      url: ajax_object.ajaxurl,
      data: str,
      success: function (data) {
        var $data = JSON.parse(data);
        if ($data['result'] != '') {
          $("#post-list-div").append($data['result']);
        } else {
          $("#post-list-div").html('<h3>No post found</h3>');
        }
        if (($data['load_more'] == '1') && ppp != '-1') {
          $("#post-lm-btn a").text('Load More');
          $("#post-lm-btn").show();
        } else {
          $("#post-lm-btn a").text('Load More');
          $("#post-lm-btn").hide();
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        $("#post-list-div").html('<h3>Something went wrong</h3>');
      }

    });
    return false;
  }

  // campaigns popup code
  const popup = document.querySelector('.popup--campaign');
  const closePopup = document.querySelector('.close-popup');
  const popupBtn = document.querySelector('.popup__button');
  // show popup on page load
  window.onload = () => {
    // if popState not set then show popup
    if(localStorage.getItem('popState') != 'shown'){
        // show popup after 4 seconds
        setTimeout(() => {
          popup.style.display = "flex";
        }, 4000);
        setTimeout(function(){
          popup.style.opacity = '100%'; 
        }, 4100);
    }
  }
  //close popup code
  const hidePopup = () => {
    popup.style.opacity = '0'; 
    setTimeout(function(){
      popup.style.display = "none";
    }, 300);
    // set popState to shown
    localStorage.setItem('popState','shown')
  }
  //close popup on close btn click
  closePopup.addEventListener('click', () => {
    hidePopup();
  });
  //close popup on popup link click
  popupBtn.addEventListener('click', () => {
    hidePopup();
  });
});
